export default "__VITE_ASSET__dc88d008__"